import React from 'react';
import { useStoreState } from 'base/store';
import AfterPayInfo from '@base/common/payMent/AfterPay/AfterPayInfo';
import RemindModal from '@base/common/payMent/RemindModal';
import styles from './index.module.less';
import Image from '@base/lib/ThemeImage';
import { isPhone } from 'base/utils/client';

type IProps = {
    className?: string;
    children?: any;
}

const AfterPayRemindModal: React.FC<IProps> = (props) => {
    const { children, className } = props

    return (
        <RemindModal
            className={className}
            modalContent={<AfterPayInfo showTitle={!isPhone}/>}
            modalTitle={(<div className={styles['title-img']}>
                <Image
                    src={'asset/width-291/picture/ade82c9b5075c6baef6de841b2e39e3f.png'}
                    width={97}
                    height={18}
                    background={false}
                />
            </div>)}
            modalProps={{
                className: styles['modal-wrap']
            }}
        >
            {children}
        </RemindModal>
    )
};

export default AfterPayRemindModal;